import styled from 'styled-components'
import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router-dom'

const ExternalResourcePage = ({ urlSrc }: { urlSrc: string }) => {
  const [childIsOpen, setChildIsOpen] = useState(false)

  useBlocker(childIsOpen)

  useEffect(() => {
    function receiveMsgFromChild(e: any) {
      //www.couponwallet.co.kr 홈페이지 코드 참고/ qnapage
      if (e?.data === 'open') {
        setChildIsOpen(true)
      } else setChildIsOpen(false)
    }

    window.addEventListener('message', receiveMsgFromChild)
    return () => {
      window.removeEventListener('message', receiveMsgFromChild)
    }
  }, [])

  return <ExternalResourceWrap src={`${process.env.REACT_APP_WEBVIEW_URL}${urlSrc}`} id="iframe" />
}
export default ExternalResourcePage

const ExternalResourceWrap = styled.iframe`
  width: 100%;
  display: flex;
  flex: 1;
`
